// send full POST request to redirectUri containing specified input fields
// inputFields contains an object that maps field name and value expected in request. Ex: { code: '<code returned from backend>' }
export const sendToRedirectUri = (redirectUri, requestType, inputFields) => {
	const form = document.createElement('form');

	// send full POST request to redirectUri
	if (redirectUri) {
		form.setAttribute('method', 'POST');
		form.setAttribute('hidden', true);
		form.setAttribute('action', redirectUri);

		// including request type in payload
		if (requestType) {
			const typeInput = document.createElement('input');
			typeInput.setAttribute('value', requestType);
			typeInput.setAttribute('name', 'type');
			form.appendChild(typeInput);
		}

		// eslint-disable-next-line no-restricted-syntax, guard-for-in
		for (const input in inputFields) {
			const inputField = document.createElement('input');
			inputField.setAttribute('value', inputFields[input]);
			inputField.setAttribute('name', input);
			form.appendChild(inputField);
		}

		document.body.appendChild(form);

		form.submit();

		if (typeof form.remove !== 'undefined') {
			form.remove();
		}
	}
};

// utility function for parsing server errors array
// from: "[{errorCode: 'LowerCase', fieldName: 'Password', message: 'Please enter a valid password.'}, ...]"
// to error object: "{LowerCase: 'Please enter a valid password.', ...}"
export const parseServerValidationErrors = errors => {
	if (!errors) return {};
	const parsedErrors = errors.reduce((accum, error) => {
		const { errorCode } = error;
		accum[errorCode] = error.message;

		return accum;
	}, {});
	return parsedErrors;
};

export const lowercaseFirstLetter = string =>
	string ? string.charAt(0).toLowerCase() + string.slice(1) : '';

export const upperCaseFirstLetter = string =>
	string ? string.charAt(0).toUpperCase() + string.slice(1) : '';

export const getValidationProps = (formikInstance, field) => {
	const { error, touched } = formikInstance.getFieldMeta(field);
	return {
		error: !!error && !!touched,
		helperText: touched && error,
	};
};

export const formatPhoneNumber = phone => {
	if (!phone) {
		return '';
	}

	phone = phone.replace(/[^\d]/g, '');
	if (phone.length < 4) {
		return `(${phone}`;
	}
	if (phone.length < 7) {
		return `(${phone.slice(0, 3)})${phone.slice(3, 6)}`;
	}
	return `(${phone.slice(0, 3)})${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
};

export const getIsASHLink = clientId =>
	clientId?.toLowerCase() === 'ashlink.code';
